import { render, staticRenderFns } from "./OTParticipantView.vue?vue&type=template&id=11367273&scoped=true"
import script from "./OTParticipantView.vue?vue&type=script&lang=js"
export * from "./OTParticipantView.vue?vue&type=script&lang=js"
import style0 from "./OTParticipantView.vue?vue&type=style&index=0&id=11367273&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11367273",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11367273')) {
      api.createRecord('11367273', component.options)
    } else {
      api.reload('11367273', component.options)
    }
    module.hot.accept("./OTParticipantView.vue?vue&type=template&id=11367273&scoped=true", function () {
      api.rerender('11367273', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OTParticipantView.vue"
export default component.exports